import { render } from "./Pealinnad.vue?vue&type=template&id=a887f452&scoped=true"
import script from "./Pealinnad.vue?vue&type=script&lang=js"
export * from "./Pealinnad.vue?vue&type=script&lang=js"

import "./Pealinnad.vue?vue&type=style&index=0&id=a887f452&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a887f452"]])

export default __exports__